import moment from 'moment'
import telSplitter from 'tel-splitter'
import meta from '@/config/meta'

export default {
  publish: (form) => {
    const fm = form
    const bs = fm.basic || {}
    const guds = fm.guardians || []
    const pg = fm.program || {}
    const pga = pg.arrangements || {}
    const phones = (bs.contacts && bs.contacts.length) ? bs.contacts.filter(it => { return (it.type && it.type === 'phone') }) : [{}]
    const mobiles = (bs.contacts && bs.contacts.length) ? bs.contacts.filter(it => { return (it.type && it.type === 'mobile') }) : [{}]
    const emails = (bs.contacts && bs.contacts.length) ? bs.contacts.filter(it => { return (it.type && it.type === 'email') }) : [{}]
    const office = fm.office || 'kumamoto'
    const officeIdx = Object.keys(meta.offices).findIndex(key => { return meta.offices[key].slug === office })
    const officeId = Object.keys(meta.offices)[officeIdx >= 0 ? officeIdx : 0]

    return {
      pageSize: 'A4',
      pageMargins: [40, 80, 40, 200],
      header: [
        {
          text: '海外留学申込書/海外滞在プログラム参加申込書',
          style: 'title'
        },
        {
          text: `${meta.offices[officeId].document.header}宛`,
          style: 'header'
        },
        {
          text: '留学プログラム約款の内容ならびに、プログラム手配のために必要な範囲内での受人機関または手配機関への個人情報の提供について同意し、プログラムに申し込みます。',
          style: 'subheader'
        }
      ],
      footer: [
        {
          margin: [40, 0, 40, 60],
          table: {
            widths: ['*'],
            body: [
              [
                {
                  border: [true, true, true, false],
                  text: '※留学申込条件書に同意し、申込みます。',
                  style: 'footerNote'
                }
              ],
              [
                {
                  border: [true, false, true, false],
                  text: [
                    '私は、申し込み条件を確認した上で、上記内容の手続きを依頼し、研修/プログラム受講中の費用に関し一切の責任を負うことに同意致します。',
                    '私は、急病や怪我で緊急の処置が必要な際、学校スタッフや現場の医療施設職員が最善と認める行動/治療方法を取ることに同意致します。'
                  ].join('\n'),
                  style: 'footerNote',
                  lineHeight: 1.2,
                  margin: [40, 5, 40, 8]
                }
              ],
              [
                {
                  border: [true, false, true, false],
                  margin: [0, 0, 0, 5],
                  columns: [
                    [
                      {
                        margin: [20, 0, 20, 0],
                        table: {
                          widths: ['*', 40, 40, 40],
                          body: [
                            [
                              {
                                border: [false, false, false, true],
                                text: '申し込み者署名',
                                style: 'signature'
                              },
                              {
                                border: [false, false, false, true],
                                text: '　'
                              },
                              {
                                border: [false, false, false, true],
                                text: '　'
                              },
                              {
                                border: [false, false, false, true],
                                text: '印',
                                style: 'signature'
                              }
                            ],
                            [
                              {
                                border: [false, false, false, false],
                                text: '記入日',
                                style: 'signature'
                              },
                              {
                                border: [false, false, false, false],
                                text: '年',
                                style: 'signature'
                              },
                              {
                                border: [false, false, false, false],
                                text: '月',
                                style: 'signature'
                              },
                              {
                                border: [false, false, false, false],
                                text: '日',
                                style: 'signature'
                              }
                            ]
                          ]
                        }
                      }
                    ],
                    [
                      {
                        margin: [20, 0, 20, 0],
                        table: {
                          widths: ['*', 40, 40, 40],
                          body: [
                            [
                              {
                                border: [false, false, false, true],
                                text: '保護者署名',
                                style: 'signature'
                              },
                              {
                                border: [false, false, false, true],
                                text: '　'
                              },
                              {
                                border: [false, false, false, true],
                                text: '　'
                              },
                              {
                                border: [false, false, false, true],
                                text: '印',
                                style: 'signature'
                              }
                            ],
                            [
                              {
                                border: [false, false, false, false],
                                text: '記入日',
                                style: 'signature'
                              },
                              {
                                border: [false, false, false, false],
                                text: '年',
                                style: 'signature'
                              },
                              {
                                border: [false, false, false, false],
                                text: '月',
                                style: 'signature'
                              },
                              {
                                border: [false, false, false, false],
                                text: '日',
                                style: 'signature'
                              }
                            ]
                          ]
                        }
                      }
                    ]
                  ]
                }
              ],
              [
                {
                  border: [true, false, true, false],
                  text: '注）必ず申込者本人が申込条件をご確認の上ご署名下さい。申し込み者が未成年もしくは学生の場合は、保護者の承諾が必要です。必ず保護者の方が直筆で署名捺印してください。',
                  style: 'footerNote',
                  fontSize: 5.8,
                  alignment: 'center',
                  lineHeight: 1.5
                }
              ],
              [
                {
                  border: [true, true, true, true],
                  table: {
                    widths: [85, 60, '*', 50],
                    body: [
                      [
                        {
                          border: [false, false, false, false],
                          text: '　'
                        },
                        {
                          border: [false, false, false, false],
                          text: '（取扱い窓口）',
                          fontSize: 6
                        },
                        {
                          border: [false, false, false, false],
                          text: [
                            {
                              text: meta.offices[officeId].document.footer,
                              style: 'companyName'
                            },
                            {
                              text: '\n' + [
                                meta.offices[officeId].document.address,
                                meta.offices[officeId].document.phone,
                                meta.offices[officeId].document.email
                              ].join('\n'),
                              fontSize: 6,
                              lineHeight: 1.1
                            }
                          ]
                        }
                      ]
                    ]
                  }
                }
              ]
            ]
          }
        }
      ],
      content: [
        {
          table: {
            widths: ['*'],
            heights: ['auto', 'auto', 'auto', 'auto', 'auto', 'auto', 220, 'auto'],
            body: [
              [
                {
                  border: [true, true, true, false],
                  text: '―お客様情報―',
                  style: 'section'
                }
              ],
              [
                {
                  border: [true, false, true, false],
                  columns: [
                    [
                      {
                        margin: [0, 0, 10, 0],
                        table: {
                          widths: [50, '*'],
                          body: [
                            [
                              {
                                border: [false, false, false, false],
                                text: [
                                  {
                                    text: '\n氏名：',
                                    style: 'label'
                                  }
                                ]
                              },
                              {
                                border: [false, false, false, false],
                                text: [
                                  {
                                    text: (bs.kana && bs.kana.length) ? bs.kana.join(' ') : '',
                                    style: 'ruby'
                                  },
                                  {
                                    text: '\n' + [
                                      (bs.name && bs.name.length) ? bs.name.join(' ') : '',
                                      (bs.hep && bs.hep.length) ? ('（' + bs.hep.join(' ') + '）') : ''
                                    ].join(''),
                                    style: 'info'
                                  }
                                ]
                              }
                            ]
                          ]
                        }
                      },
                      {
                        margin: [0, 0, 10, 0],
                        table: {
                          widths: [50, '*'],
                          body: [
                            [
                              {
                                border: [false, false, false, false],
                                text: [
                                  {
                                    text: '',
                                    fontSize: 6
                                  },
                                  {
                                    text: '\n住所:',
                                    style: 'label'
                                  }
                                ]
                              },
                              {
                                border: [false, false, false, false],
                                text: [
                                  {
                                    text: [
                                      (bs.addresses && bs.addresses.length && bs.addresses[0].zip) ? ('〒' + bs.addresses[0].zip) : '',
                                      (bs.addresses && bs.addresses.length && bs.addresses[0].kana) ? bs.addresses[0].kana : ''
                                    ].join(' '),
                                    style: 'ruby'
                                  },
                                  {
                                    text: '\n' + [
                                      (bs.addresses && bs.addresses.length && bs.addresses[0].pref) ? bs.addresses[0].pref : '',
                                      (bs.addresses && bs.addresses.length && bs.addresses[0].city) ? bs.addresses[0].city : '',
                                      (bs.addresses && bs.addresses.length && bs.addresses[0].number) ? bs.addresses[0].number : ''
                                    ].join(''),
                                    style: 'info'
                                  }
                                ]
                              }
                            ]
                          ]
                        }
                      },
                      {
                        margin: [0, 0, 10, 0],
                        table: {
                          widths: [50, '*'],
                          body: [
                            [
                              {
                                border: [false, false, false, false],
                                text: '固定電話：',
                                style: 'label'
                              },
                              {
                                border: [false, false, false, false],
                                text: phones.length ? telSplitter.format(phones[0].contact) : '',
                                style: 'info'
                              }
                            ],
                            [
                              {
                                border: [false, false, false, false],
                                text: '携帯電話：',
                                style: 'label'
                              },
                              {
                                border: [false, false, false, false],
                                text: mobiles.length ? telSplitter.format(mobiles[0].contact) : '',
                                style: 'info'
                              }
                            ],
                            [
                              {
                                border: [false, false, false, false],
                                text: 'Eメール：',
                                style: 'label'
                              },
                              {
                                border: [false, false, false, false],
                                text: emails.length ? emails[0].contact : '',
                                style: 'info'
                              }
                            ]
                          ]
                        }
                      }
                    ],
                    {
                      width: 170,
                      margin: [0, 3, 0, 0],
                      table: {
                        widths: [50, '*'],
                        body: [
                          [
                            {
                              border: [false, false, false, false],
                              text: '性別：',
                              style: 'label'
                            },
                            {
                              border: [false, false, false, false],
                              text: (bs.sex && bs.sex.content && meta.sex[bs.sex.content]) ? meta.sex[bs.sex.content] : '',
                              style: 'info'
                            }
                          ],
                          [
                            {
                              border: [false, false, false, false],
                              text: '生年月日：',
                              style: 'label'
                            },
                            {
                              border: [false, false, false, false],
                              text: (bs.birthday && bs.birthday.content) ? moment(bs.birthday.content).format('YYYY年MM月DD日') : '',
                              style: 'info'
                            }
                          ],
                          [
                            {
                              border: [false, false, false, false],
                              text: '婚姻歴：',
                              style: 'label'
                            },
                            {
                              border: [false, false, false, false],
                              text: (bs.marry && bs.marry.content) ? bs.marry.content : '',
                              style: 'info'
                            }
                          ],
                          [
                            {
                              border: [false, false, false, false],
                              text: '国籍：',
                              style: 'label'
                            },
                            {
                              border: [false, false, false, false],
                              text: (bs.nationality && bs.nationality.content && meta.nations[bs.nationality.content]) ? meta.nations[bs.nationality.content] : '',
                              style: 'info'
                            }
                          ],
                          [
                            {
                              border: [false, false, false, false],
                              text: '出生地：',
                              style: 'label'
                            },
                            {
                              border: [false, false, false, false],
                              text: (bs.birthplace && bs.birthplace.content) ? bs.birthplace.content : '',
                              style: 'info'
                            }
                          ]
                        ]
                      }
                    }
                  ],
                  margin: [0, 0, 0, 2]
                }
              ],
              [
                {
                  border: [true, true, true, false],
                  text: '―保護者情報―',
                  style: 'section'
                }
              ],
              [
                {
                  border: [true, false, true, false],
                  columns: guds.map(it => {
                    return [
                      {
                        margin: [0, 0, 5, 0],
                        table: {
                          widths: [45, '*', 30, '*'],
                          body: [
                            [
                              {
                                border: [false, false, false, false],
                                text: [
                                  {
                                    text: '\n氏名：',
                                    style: 'label'
                                  }
                                ]
                              },
                              {
                                border: [false, false, false, false],
                                text: [
                                  {
                                    text: (it.kana && it.kana.length) ? it.kana.join(' ') : '',
                                    style: 'ruby'
                                  },
                                  {
                                    text: '\n' + ((it.name && it.name.length) ? it.name.join(' ') : ''),
                                    style: 'info'
                                  }
                                ]
                              },
                              {
                                border: [false, false, false, false],
                                text: [
                                  {
                                    text: '\n続柄：',
                                    style: 'label'
                                  }
                                ]
                              },
                              {
                                border: [false, false, false, false],
                                text: [
                                  {
                                    text: '\n' + (it.relation ? it.relation : ''),
                                    style: 'info'
                                  }
                                ]
                              }
                            ]
                          ]
                        }
                      },
                      {
                        margin: [0, 0, 5, 0],
                        table: {
                          widths: [45, '*'],
                          body: [
                            [
                              {
                                border: [false, false, false, false],
                                text: [
                                  {
                                    text: '\n住所：',
                                    style: 'label'
                                  }
                                ]
                              },
                              {
                                border: [false, false, false, false],
                                text: [
                                  {
                                    text: [
                                      (it.addresses && it.addresses.length && it.addresses[0].zip) ? ('〒' + it.addresses[0].zip) : '',
                                      (it.addresses && it.addresses.length && it.addresses[0].kana) ? it.addresses[0].kana : ''
                                    ].join(' '),
                                    style: 'ruby'
                                  },
                                  {
                                    text: '\n' + [
                                      (it.addresses && it.addresses.length && it.addresses[0].pref) ? it.addresses[0].pref : '',
                                      (it.addresses && it.addresses.length && it.addresses[0].city) ? it.addresses[0].city : '',
                                      (it.addresses && it.addresses.length && it.addresses[0].number) ? it.addresses[0].number : ''
                                    ].join(''),
                                    style: 'info'
                                  }
                                ]
                              }
                            ],
                            [
                              {
                                border: [false, false, false, false],
                                text: (it.contacts && it.contacts.length && it.contacts[0].type && meta.contacts[it.contacts[0].type]) ? (meta.contacts[it.contacts[0].type] + '：') : '',
                                style: 'label'
                              },
                              {
                                border: [false, false, false, false],
                                text: (it.contacts && it.contacts.length && it.contacts[0].contact) ? telSplitter.format(it.contacts[0].contact) : '',
                                style: 'info'
                              }
                            ]
                          ]
                        }
                      }
                    ]
                  }),
                  margin: [0, 0, 0, 10]
                }
              ],
              [
                {
                  border: [true, true, true, false],
                  text: '―参加希望コース内容―',
                  style: 'section'
                }
              ],
              [
                {
                  border: [true, false, true, false],
                  table: {
                    widths: [50, '*'],
                    body: [
                      [
                        {
                          border: [false, false, false, false],
                          text: '学校名：',
                          style: 'label'
                        },
                        {
                          border: [false, false, false, false],
                          text: pg.title ? pg.title : '',
                          style: 'info'
                        }
                      ],
                      [
                        {
                          border: [false, false, false, false],
                          text: '留学先：',
                          style: 'label'
                        },
                        {
                          border: [false, false, false, false],
                          text: [
                            '国）' + ((pg.country && meta.nations[pg.country]) ? meta.nations[pg.country] : ''),
                            '都市）' + (pg.city ? pg.city : '')
                          ].join('　'),
                          style: 'info'
                        }
                      ]
                    ]
                  }
                }
              ],
              [
                {
                  margin: [0, 0, 0, 5],
                  border: [true, false, true, false],
                  columns: [
                    [
                      {
                        margin: [0, 0, 5, 0],
                        table: {
                          widths: [50, '*'],
                          headerRows: 1,
                          body: [
                            [
                              {
                                text: '―コース―',
                                style: 'subsection',
                                colSpan: 2,
                                border: [false, false, false, false]
                              }, {}
                            ]
                          ].concat(
                            (pg.courses && pg.courses.length) ? pg.courses.map(it => {
                              return [
                                {
                                  border: [false, false, false, true],
                                  text: [
                                    {
                                      text: 'コース名：',
                                      style: 'sectionTitle',
                                      bold: true
                                    },
                                    {
                                      text: '\n' + [
                                        'レッスン数：',
                                        '期間：'
                                      ].join('\n'),
                                      style: 'sectionTitle',
                                      bold: true
                                    }
                                  ]
                                },
                                {
                                  border: [false, false, false, true],
                                  text: [
                                    {
                                      text: it.title ? it.title : '',
                                      style: 'sectionTitle'
                                    },
                                    {
                                      text: '\n' + [
                                        [
                                          (it.lesson && it.lesson.size != null) ? it.lesson.size : '',
                                          (it.lesson && it.lesson.unit) ? it.lesson.unit : ''
                                        ].join(''),
                                        [
                                          [
                                            (it.dates && it.dates.start) ? moment(it.dates.start).format('YYYY年MM月DD日') : '',
                                            (it.dates && it.dates.end) ? moment(it.dates.end).format('YYYY年MM月DD日') : ''
                                          ].join((it.dates && (it.dates.start || it.dates.end)) ? '〜' : ''),
                                          '（',
                                          [
                                            (it.term && it.term.size != null) ? it.term.size : '',
                                            (it.term && it.term.unit) ? it.term.unit : ''
                                          ].join(''),
                                          (it.term && it.term.size != null && it.term.unit && it.extra && it.extra.size != null && it.extra.unit) ? 'と' : '',
                                          [
                                            (it.extra && it.extra.size != null) ? it.extra.size : '',
                                            (it.extra && it.extra.unit) ? it.extra.unit : ''
                                          ].join(''),
                                          '）'
                                        ].join('').replace('（）', '')
                                      ].join('\n'),
                                      style: 'sectionTitle'
                                    }
                                  ]
                                }
                              ]
                            }) : []
                          )
                        }
                      }
                    ],
                    [
                      {
                        margin: [5, 0, 0, 0],
                        table: {
                          widths: [35, '*'],
                          headerRows: 1,
                          body: [
                            [
                              {
                                text: '―宿泊先―',
                                style: 'subsection',
                                colSpan: 2,
                                border: [false, false, false, false]
                              }, {}
                            ]
                          ].concat(
                            (pg.stays && pg.stays.length) ? pg.stays.map(it => {
                              return [
                                {
                                  border: [false, false, false, true],
                                  text: [
                                    {
                                      text: '宿泊先：',
                                      style: 'sectionTitle',
                                      bold: true
                                    },
                                    {
                                      text: '\n' + [
                                        'タイプ：',
                                        '期間：'
                                      ].join('\n'),
                                      style: 'sectionTitle',
                                      bold: true
                                    }
                                  ]
                                },
                                {
                                  border: [false, false, false, true],
                                  text: [
                                    {
                                      text: it.title ? it.title : '',
                                      style: 'sectionTitle'
                                    },
                                    {
                                      text: '\n' + [
                                        it.type ? it.type : '',
                                        [
                                          [
                                            (it.dates && it.dates.start) ? moment(it.dates.start).format('YYYY年MM月DD日') : '',
                                            (it.dates && it.dates.end) ? moment(it.dates.end).format('YYYY年MM月DD日') : ''
                                          ].join((it.dates && (it.dates.start || it.dates.end)) ? '〜' : ''),
                                          '（',
                                          [
                                            (it.term && it.term.size != null) ? it.term.size : '',
                                            (it.term && it.term.unit) ? it.term.unit : ''
                                          ].join(''),
                                          (it.term && it.term.size != null && it.term.unit && it.extra && it.extra.size != null && it.extra.unit) ? 'と' : '',
                                          [
                                            (it.extra && it.extra.size != null) ? it.extra.size : '',
                                            (it.extra && it.extra.unit) ? it.extra.unit : ''
                                          ].join(''),
                                          '）'
                                        ].join('').replace('（）', '')
                                      ].join('\n'),
                                      style: 'sectionTitle'
                                    }
                                  ]
                                }
                              ]
                            }) : []
                          )
                        }
                      }
                    ]
                  ]
                }
              ],
              [
                {
                  border: [true, true, true, true],
                  columns: [
                    [
                      {
                        margin: [2, 0, 2, 0],
                        table: {
                          headerRows: 1,
                          widths: ['*'],
                          body: [
                            [
                              {
                                border: [false, false, false, false],
                                text: '―航空券―',
                                style: 'subsection'
                              }
                            ],
                            [
                              {
                                border: [false, false, false, false],
                                text: (pga.flight && pga.flight.status) ? pga.flight.status : '',
                                fontSize: 8,
                                alignment: 'center'
                              }
                            ]
                          ]
                        }
                      }
                    ],
                    [
                      {
                        margin: [2, 0, 2, 0],
                        table: {
                          headerRows: 1,
                          widths: ['*'],
                          body: [
                            [
                              {
                                border: [false, false, false, false],
                                text: '―海外保険―',
                                style: 'subsection'
                              }
                            ],
                            [
                              {
                                border: [false, false, false, false],
                                text: (pga.insurance && pga.insurance.status) ? pga.insurance.status : '',
                                fontSize: 8,
                                alignment: 'center'
                              }
                            ]
                          ]
                        }
                      }
                    ],
                    [
                      {
                        margin: [2, 0, 2, 0],
                        table: {
                          headerRows: 1,
                          widths: ['*'],
                          body: [
                            [
                              {
                                border: [false, false, false, false],
                                text: '―査証―',
                                style: 'subsection'
                              }
                            ],
                            [
                              {
                                border: [false, false, false, false],
                                text: [
                                  (pga.visa && pga.visa.status) ? pga.visa.status : '',
                                  [
                                    (pga.visa && pga.visa.type) ? pga.visa.type : '',
                                    (pga.visa && pga.visa.local) ? '（現地申請）' : ''
                                  ].join('')
                                ].join('\n'),
                                fontSize: 8,
                                alignment: 'center'
                              }
                            ]
                          ]
                        }
                      }
                    ],
                    [
                      {
                        margin: [2, 0, 2, 0],
                        table: {
                          headerRows: 1,
                          widths: ['*'],
                          body: [
                            [
                              {
                                border: [false, false, false, false],
                                text: '―空港送迎―',
                                style: 'subsection'
                              }
                            ],
                            [
                              {
                                border: [false, false, false, false],
                                text: [
                                  (pga.pickup && pga.pickup.status) ? pga.pickup.status : '',
                                  [
                                    (pga.pickup && pga.pickup.name) ? pga.pickup.name : '',
                                    (pga.pickup && pga.pickup.type) ? `（${pga.pickup.type}）` : ''
                                  ].join('')
                                ].join('\n'),
                                fontSize: 8,
                                alignment: 'center'
                              }
                            ]
                          ]
                        }
                      }
                    ]
                  ]
                }
              ]
            ]
          }
        }
      ],
      styles: {
        title: {
          fontSize: 15,
          bold: true,
          alignment: 'center',
          margin: [0, 30, 0, 5]
        },
        header: {
          fontSize: 13,
          margin: [40, 0, 40, 5]
        },
        subheader: {
          fontSize: 6.5,
          margin: [40, 0, 40, 0]
        },
        footerNote: {
          fontSize: 6.5,
          margin: [5, 5, 5, 0]
        },
        section: {
          fontSize: 12,
          bold: true,
          margin: [5, 5, 0, 0]
        },
        subsection: {
          fontSize: 10,
          alignment: 'center',
          bold: true,
          margin: [0, 2, 0, 0]
        },
        sectionTitle: {
          fontSize: 10,
          lineHeight: 1.2
        },
        sectionSubTitle: {
          fontSize: 7,
          lineHeight: 1.2
        },
        label: {
          fontSize: 10,
          bold: true
        },
        ruby: {
          fontSize: 7
        },
        info: {
          fontSize: 10
        },
        signature: {
          fontSize: 6,
          alignment: 'center',
          margin: [0, 3, 0, 0]
        },
        companyName: {
          fontSize: 10,
          lineHeight: 1.5,
          bold: true
        }
      },
      defaultStyle: {
        font: 'AozoraMincho'
      }
    }
  }
}
